import { Locale, type LocalizedString } from "../Locale.js";

export const b2bApplicationPathMap = {
	[Locale.cs]: "chci-byt-partnerem" as const,
} satisfies LocalizedString;
